import { CloseOutlined } from "@mui/icons-material";
import { Box, Modal } from "@mui/material";
import { NidcomLogo } from "../LayoutIcons";

const ImgBackgroundModal = ({
  showModal,
  onCloseModal,
  btnActtion,
  headerText,
  subTextDiv,
  additionalInfoDiv,
  disabled,
  children,
}: {
  showModal: boolean;
  onCloseModal: () => void;
  btnActtion: () => void;
  headerText: string;
  subTextDiv?: JSX.Element;
  additionalInfoDiv?: JSX.Element;
  disabled?: boolean;
  children: JSX.Element;
}) => {
  return (
    <Modal
      className="imgbg-modal-bg"
      open={showModal}
      onClose={onCloseModal}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="imgbg-modal">
        <div className="modal-close-button" onClick={onCloseModal}>
          <CloseOutlined />
        </div>
        <div className="modal-top">
          <div>
            <NidcomLogo />
          </div>
          <div>Simplifying Property Purchases in Nigeria</div>
        </div>
        <div className="modal-main">
          <div className="_header">{headerText}</div>
          {children}
        </div>
        <div className="modal-bottom">
          {subTextDiv}
          <div className="_buttons">
            <button onClick={onCloseModal} className="outline-button">
              Cancel
            </button>
            <button
              onClick={btnActtion}
              disabled={disabled}
              className="filled-button"
            >
              Continue
            </button>
          </div>
          {additionalInfoDiv}
        </div>
      </Box>
    </Modal>
  );
};

export default ImgBackgroundModal;
